﻿import { Model } from "@vuex-orm/core";

export interface contactTagEntity {
  tagId: number;
  name: string;
  description: string;
  isPinned: boolean;
  isGlobal: boolean;
  isApprover: boolean;
}
export class contactTagEntity extends Model {
  static entity = "contactTagEntity";
  static primaryKey = "tagId";
  static fields() {
    return {
      tagId: this.number(0),
      name: this.string(""),
      description: this.string(""),
      isPinned: this.boolean(false),
      isGlobal: this.boolean(false),
      isApprover: this.boolean(false),
    };
  }

  get tagName(): string {
    return this.name;
  }
}
